module.exports = __webpack_public_path__ + "static/media/the_4.2399fc59.png";